var map = {
	"./director/DirectorAboutSchool.vue": [
		"3116",
		"chunk-5fec016c"
	],
	"./director/DirectorChat.vue": [
		"6f64",
		"chunk-597eb11b",
		"chunk-662fb677"
	],
	"./director/DirectorClasses.vue": [
		"ccd3",
		"chunk-67abc3b0"
	],
	"./director/DirectorCourses.vue": [
		"a83b",
		"chunk-2d2091bc"
	],
	"./director/DirectorDashboard.vue": [
		"d4be",
		"chunk-5f7bcf6c"
	],
	"./director/DirectorManage.vue": [
		"e98d",
		"chunk-2c7c6942",
		"chunk-618f1d6e"
	],
	"./director/DirectorReport.vue": [
		"6362",
		"chunk-6c054263",
		"chunk-c50e92e6"
	],
	"./director/DirectorScheduleWeek.vue": [
		"b11d",
		"chunk-64b0c1eb",
		"chunk-16d9907e"
	],
	"./director/DirectorShift.vue": [
		"31e2",
		"chunk-1c12d495",
		"chunk-1d2cfca4"
	],
	"./director/DirectorStudents.vue": [
		"1727",
		"chunk-1d6b7346"
	],
	"./director/DirectorTeachers.vue": [
		"1881f",
		"chunk-744d4ad0"
	],
	"./instructor/InstructorAnnouncement.vue": [
		"aa52",
		"chunk-24722e76"
	],
	"./instructor/InstructorChat.vue": [
		"fe82",
		"chunk-597eb11b",
		"chunk-d1cb0340"
	],
	"./instructor/InstructorClasses.vue": [
		"f130",
		"chunk-249c84f0"
	],
	"./instructor/InstructorDashboard.vue": [
		"b3dc",
		"chunk-5d3b2c98"
	],
	"./instructor/InstructorForm.vue": [
		"a528",
		"chunk-02fa0ac0"
	],
	"./instructor/InstructorJournalGrade.vue": [
		"57e5",
		"chunk-64b0c1eb",
		"chunk-74669738"
	],
	"./instructor/InstructorManage.vue": [
		"91ff",
		"chunk-2c7c6942",
		"chunk-6c1166d1",
		"chunk-d9abb3c8"
	],
	"./instructor/InstructorOnlineLesson.vue": [
		"52f7",
		"chunk-277887a4"
	],
	"./instructor/InstructorQuarterGrade.vue": [
		"4f7d",
		"chunk-4635578c"
	],
	"./instructor/InstructorReport.vue": [
		"453c",
		"chunk-3964e78a"
	],
	"./instructor/InstructorSchedule.vue": [
		"0587",
		"chunk-7cbc5b86"
	],
	"./instructor/InstructorTopic.vue": [
		"8766",
		"chunk-6aa45429"
	],
	"./instructor/InstructorVideoMaterial.vue": [
		"e2cc1",
		"chunk-2ac7323e"
	],
	"./instructor/StudyMaterial.vue": [
		"8e2d",
		"chunk-48dff33e"
	],
	"./landing/AboutProject.vue": [
		"bb0f",
		"chunk-34c45cfd"
	],
	"./landing/Connection.vue": [
		"9df8",
		"chunk-2d0f0e13"
	],
	"./landing/Faq.vue": [
		"ed61",
		"chunk-2d230890"
	],
	"./landing/Footer.vue": [
		"2885"
	],
	"./landing/FooterSmall.vue": [
		"f9e1",
		"chunk-125a800b"
	],
	"./landing/GosOpportunity.vue": [
		"88dc",
		"chunk-8bda4a0e"
	],
	"./landing/MainOpportunities.vue": [
		"89c9",
		"chunk-187b02d6"
	],
	"./landing/MainPage.vue": [
		"1dd8",
		"chunk-286889e0"
	],
	"./landing/Navbar.vue": [
		"8e23"
	],
	"./landing/Opportunities.vue": [
		"043d",
		"chunk-31f742c7"
	],
	"./landing/ParentOpportunity.vue": [
		"b9d4",
		"chunk-75093632"
	],
	"./landing/StudentOpportunity.vue": [
		"1d6d",
		"chunk-4fd50c84"
	],
	"./landing/Support.vue": [
		"8b6e",
		"chunk-5d17e642"
	],
	"./landing/TeacherOpportunity.vue": [
		"2259",
		"chunk-0c0a56de"
	],
	"./librarian/LibrarianManage.vue": [
		"89dd",
		"chunk-2c7c6942",
		"chunk-6c1166d1",
		"chunk-e1d37b5e"
	],
	"./login/Login.vue": [
		"ede4"
	],
	"./login/LoginEkyzmat.vue": [
		"bf5d",
		"chunk-2d21b309"
	],
	"./login/LoginEsi.vue": [
		"e807",
		"chunk-2d2262b0"
	],
	"./min-education/AdminGradeReason.vue": [
		"0a40",
		"chunk-76549bcb"
	],
	"./min-education/Chronicle.vue": [
		"fca0",
		"chunk-7a01bf8e"
	],
	"./min-education/Courses.vue": [
		"7601",
		"chunk-65e58fa0"
	],
	"./min-education/Dashboard.vue": [
		"d8bc",
		"chunk-0f986f3c"
	],
	"./min-education/Director.vue": [
		"fb7a",
		"chunk-5ad8caf9"
	],
	"./min-education/Instructor.vue": [
		"384a",
		"chunk-6323b0d9"
	],
	"./min-education/MinEducationManage.vue": [
		"5888",
		"chunk-2c7c6942",
		"chunk-07a3d3dd"
	],
	"./min-education/Rayon.vue": [
		"9907",
		"chunk-2d0e661d"
	],
	"./min-education/RayonHead.vue": [
		"4cdd",
		"chunk-36e58cba"
	],
	"./min-education/SchoolAdmin.vue": [
		"9f7c",
		"chunk-6bf25ed2"
	],
	"./min-education/Schools.vue": [
		"aacc",
		"chunk-26aeb887"
	],
	"./min-education/Students.vue": [
		"4f42",
		"chunk-737a0461"
	],
	"./min-education/VideoMaterial.vue": [
		"9574",
		"chunk-1be76100"
	],
	"./parents/Notification.vue": [
		"75cf",
		"chunk-43b0030e"
	],
	"./parents/ParentChat.vue": [
		"46c0",
		"chunk-597eb11b",
		"chunk-4c52f730"
	],
	"./parents/ParentChatComponent.vue": [
		"775b",
		"chunk-597eb11b",
		"chunk-2d0d76a3"
	],
	"./parents/ParentManager.vue": [
		"0ac7",
		"chunk-2c7c6942",
		"chunk-621dd9d3"
	],
	"./parents/QuarterGrade.vue": [
		"0b42",
		"chunk-acf4d9de"
	],
	"./parents/StudyMaterial.vue": [
		"dc07",
		"chunk-9e2d80d8"
	],
	"./parents/WeekSchedule.vue": [
		"88bf",
		"chunk-f5328142"
	],
	"./rayon-head/Calendar.vue": [
		"3dc9",
		"chunk-fe5ed966"
	],
	"./rayon-head/Dashboard.vue": [
		"21ce",
		"chunk-2bc680f1"
	],
	"./rayon-head/Instructors.vue": [
		"3006",
		"chunk-584ed143"
	],
	"./rayon-head/RayonHeadManage.vue": [
		"1c49",
		"chunk-2c7c6942",
		"chunk-e6434ad4"
	],
	"./rayon-head/RayonHeadReport.vue": [
		"7c12",
		"chunk-6c054263",
		"chunk-fe474fe2"
	],
	"./rayon-head/Schools.vue": [
		"ac91",
		"chunk-3c913ad2"
	],
	"./rayon-head/Students.vue": [
		"b710",
		"chunk-14008e53"
	],
	"./school-admin/AboutSchool.vue": [
		"3f2f",
		"chunk-22e623be"
	],
	"./school-admin/Announcements.vue": [
		"d4ab",
		"chunk-5395601c"
	],
	"./school-admin/ArchiveUsers.vue": [
		"e5eb",
		"chunk-29107b32"
	],
	"./school-admin/Dashboard.vue": [
		"2fff"
	],
	"./school-admin/Library.vue": [
		"849c",
		"chunk-dc6c99f2"
	],
	"./school-admin/QuarterCalendar.vue": [
		"9f6f",
		"chunk-4ec8eac1"
	],
	"./school-admin/ReplaceInstructor.vue": [
		"e089",
		"chunk-6f170243"
	],
	"./school-admin/SchoolAdminChat.vue": [
		"26a2",
		"chunk-597eb11b",
		"chunk-662d35fe"
	],
	"./school-admin/SchoolAdminClasses.vue": [
		"28b9",
		"chunk-aea598c6"
	],
	"./school-admin/SchoolAdminCourses.vue": [
		"a925"
	],
	"./school-admin/SchoolAdminManage.vue": [
		"1a88",
		"chunk-2c7c6942",
		"chunk-6c1166d1",
		"chunk-76ea464e"
	],
	"./school-admin/SchoolAdminReport.vue": [
		"fa3c",
		"chunk-6c054263",
		"chunk-79a6e44e"
	],
	"./school-admin/SchoolAdminScheduleWeek.vue": [
		"9e18",
		"chunk-64b0c1eb",
		"chunk-713d8800"
	],
	"./school-admin/SchoolAdminVideoMaterial.vue": [
		"c138",
		"chunk-7ab9aab4"
	],
	"./school-admin/Shift.vue": [
		"8ef1",
		"chunk-1c12d495"
	],
	"./school-admin/Students.vue": [
		"89a2",
		"chunk-5d122502"
	],
	"./school-admin/StudyMaterial.vue": [
		"d38b",
		"chunk-5b926f31"
	],
	"./school-admin/Teachers.vue": [
		"f342"
	],
	"./school-admin/school-preset/QuarterInitCreate.vue": [
		"f57d",
		"chunk-aee0be4e"
	],
	"./school-admin/school-preset/SetInitQuarter.vue": [
		"8346",
		"chunk-9da8c79c"
	],
	"./settings/ChangePassword.vue": [
		"f2df",
		"chunk-24dfa356"
	],
	"./settings/Profile.vue": [
		"3469",
		"chunk-2b7d94c7"
	],
	"./settings/SettingsManage.vue": [
		"7ac3",
		"chunk-2c7c6942",
		"chunk-6c1166d1",
		"chunk-5312d36e"
	],
	"./student/DaysMonths.vue": [
		"a875",
		"chunk-2da638a1"
	],
	"./student/Hymn.vue": [
		"6277",
		"chunk-4a049c0d"
	],
	"./student/KgAlphabet.vue": [
		"8210",
		"chunk-63492161"
	],
	"./student/Manas.vue": [
		"3cff",
		"chunk-24a34ca8"
	],
	"./student/MultTable.vue": [
		"f47a",
		"chunk-54af9d26"
	],
	"./student/Notification.vue": [
		"2d8f",
		"chunk-60c3bf24"
	],
	"./student/OnlineLesson.vue": [
		"1e3b",
		"chunk-4fa8922a"
	],
	"./student/Plane.vue": [
		"71e0",
		"chunk-24b8d80a"
	],
	"./student/QuarterGrade.vue": [
		"f9e3",
		"chunk-49fbd89a"
	],
	"./student/ScheduleWeek.vue": [
		"e7e3",
		"chunk-b7c3ac08"
	],
	"./student/StudentChat.vue": [
		"8347",
		"chunk-597eb11b",
		"chunk-54f895c1"
	],
	"./student/StudentManage.vue": [
		"2fbd",
		"chunk-2c7c6942",
		"chunk-697bb5ff"
	],
	"./super-admin/AdminGradeReason.vue": [
		"188a",
		"chunk-1afe9b00"
	],
	"./super-admin/Announcements.vue": [
		"90e5",
		"chunk-57daa9a0"
	],
	"./super-admin/Calendar.vue": [
		"0ddc"
	],
	"./super-admin/Chronicle.vue": [
		"6ea8",
		"chunk-6431824b"
	],
	"./super-admin/Courses.vue": [
		"4184"
	],
	"./super-admin/Director.vue": [
		"6d68",
		"chunk-c3a2a734"
	],
	"./super-admin/Instructor.vue": [
		"c93d"
	],
	"./super-admin/Library.vue": [
		"ba93",
		"chunk-d7a405d8"
	],
	"./super-admin/Rayon.vue": [
		"c1d2"
	],
	"./super-admin/RayonHead.vue": [
		"612d",
		"chunk-1c031a4c"
	],
	"./super-admin/SchoolAdmin.vue": [
		"841b"
	],
	"./super-admin/Schools.vue": [
		"3d70",
		"chunk-69d53f53"
	],
	"./super-admin/SearchUser.vue": [
		"9ae5",
		"chunk-5ab6fc90"
	],
	"./super-admin/Students.vue": [
		"f7dd"
	],
	"./super-admin/SuperAdminChat.vue": [
		"3e1d",
		"chunk-597eb11b",
		"chunk-54f70b68"
	],
	"./super-admin/SuperAdminDashboard.vue": [
		"9921",
		"chunk-92a8be8c"
	],
	"./super-admin/SuperAdminManage.vue": [
		"7f5c",
		"chunk-2c7c6942",
		"chunk-25316697"
	],
	"./super-admin/VideoMaterial.vue": [
		"4843",
		"chunk-185c07b6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;